var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52659 2.493V9H8.46009V4.797C8.46009 4.629 8.46909 4.4475 8.48709 4.2525L6.52059 7.947C6.42759 8.124 6.28509 8.2125 6.09309 8.2125H5.92209C5.73009 8.2125 5.58759 8.124 5.49459 7.947L3.50559 4.239C3.51459 4.338 3.52209 4.4355 3.52809 4.5315C3.53409 4.6275 3.53709 4.716 3.53709 4.797V9H2.47059V2.493H3.38409C3.43809 2.493 3.48459 2.4945 3.52359 2.4975C3.56259 2.5005 3.59709 2.508 3.62709 2.52C3.66009 2.532 3.68859 2.5515 3.71259 2.5785C3.73959 2.6055 3.76509 2.6415 3.78909 2.6865L5.73759 6.3C5.78859 6.396 5.83509 6.495 5.87709 6.597C5.92209 6.699 5.96559 6.804 6.00759 6.912C6.04959 6.801 6.09309 6.6945 6.13809 6.5925C6.18309 6.4875 6.23109 6.387 6.28209 6.291L8.20359 2.6865C8.22759 2.6415 8.25309 2.6055 8.28009 2.5785C8.30709 2.5515 8.33559 2.532 8.36559 2.52C8.39859 2.508 8.43459 2.5005 8.47359 2.4975C8.51259 2.4945 8.55909 2.493 8.61309 2.493H9.52659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualQuotation);
export default __webpack_public_path__ + "static/media/manualQuotation.d188a23e93666646b53dba034c9bf5fc.svg";
export { ForwardRef as ReactComponent };